const WRITE_PRECISIONS_FR = 'ÉCRIRE LES PRÉCISIONS...';
const WRITE_PRECISIONS_EN = 'WRITE PRECISIONS...';
const DATE_FORMAT_FR = 'JJ/MM/AAAA';
const DATE_FORMAT_EN = 'DD/MM/YYYY';
const DIAGNOSIS_FR = 'POSOLOGIE';
const DIAGNOSIS_EN = 'POSOLOGY';
const HOSPITALIZATION_FR = `${DATE_FORMAT_FR} ET PENDANT X JOURS`;
const HOSPITALIZATION_EN = `${DATE_FORMAT_EN} AND FOR X DAYS`;
const TREATMENT_AND_MEDICATION_FR = 'NOM, DOSE, FRÉQUENCE/POSOLOGIE';
const TREATMENT_AND_MEDICATION_EN = 'NAME, DOSE, FREQUENCE/POSOLOGY';
const ABSENCE_FROM_WORK_FR = `${DATE_FORMAT_FR} ET PENDANT X JOURS`;
const ABSENCE_FROM_WORK_EN = `${DATE_FORMAT_EN} AND FOR X DAYS`;
const TREATING_PHYSICIAN_FR = 'NOM COMPLET (ADRESSE)';
const TREATING_PHYSICIAN_EN = 'FULL NAME (ADDRESS)';
const OTHER_FR = "INSCRIRE D'AUTRES INFORMATIONS IMPORTANTES...";
const OTHER_EN = 'WRITE OTHER IMPORTANT INFORMATION...';

export const EXTRA_QUESTIONNAIRE_DETAILS_TEMPLATE_PROMPTS = [
  WRITE_PRECISIONS_FR,
  WRITE_PRECISIONS_EN,
  DATE_FORMAT_FR,
  DATE_FORMAT_EN,
  DIAGNOSIS_FR,
  DIAGNOSIS_EN,
  HOSPITALIZATION_FR,
  HOSPITALIZATION_EN,
  TREATMENT_AND_MEDICATION_FR,
  TREATMENT_AND_MEDICATION_EN,
  ABSENCE_FROM_WORK_FR,
  ABSENCE_FROM_WORK_EN,
  TREATING_PHYSICIAN_FR,
  TREATING_PHYSICIAN_EN,
  OTHER_FR,
  OTHER_EN,
];

export const EXTRA_QUESTIONNAIRE_DETAILS_FR_TEMPLATE = `Précision : ${WRITE_PRECISIONS_FR}
Date de début : ${DATE_FORMAT_FR}
Date de fin : ${DATE_FORMAT_FR}
Diagnostic : ${DIAGNOSIS_FR}
Hospitalisation : ${HOSPITALIZATION_FR}
Traitement et médication : ${TREATMENT_AND_MEDICATION_FR}
Absence du travail : ${ABSENCE_FROM_WORK_FR}
Médecin traitant : ${TREATING_PHYSICIAN_FR}
Autre : ${OTHER_FR}`;

export const EXTRA_QUESTIONNAIRE_DETAILS_EN_TEMPLATE = `Precision: ${WRITE_PRECISIONS_EN}
Start date: ${DATE_FORMAT_EN}
End date: ${DATE_FORMAT_EN}
Diagnosis: ${DIAGNOSIS_EN}
Hospitalization: ${HOSPITALIZATION_EN}
Treatment and Medication: ${TREATMENT_AND_MEDICATION_EN}
Absence from work: ${ABSENCE_FROM_WORK_EN}
Treating physician: ${TREATING_PHYSICIAN_EN}
Other: ${OTHER_EN}`;
